module.exports = "/images/loader-cropped.svg?2d06f8b9b95d9d063be7b97c1268c897";